document.addEventListener('DOMContentLoaded', () => {


  //Login Form change password visibility
  document.querySelectorAll('.nc-account-login form .login-password').forEach(wrapper => {
    const input = wrapper.querySelector('input');
    const psevdo = document.createElement('div')
    psevdo.classList.add('nc-account-password-visibility')
    psevdo.addEventListener('click', () => {
      input.type = input.type === 'password' ? 'text' : 'password';
      psevdo.classList.toggle('active')
    })

    wrapper.appendChild(psevdo);
  })

  //deactivate domain activation listener
  document.querySelectorAll('.nc-account-area [data-deactivate]').
      forEach(el => {
        el.addEventListener('click', async (e) => {
          e.preventDefault();

          const FD = new FormData();
          FD.append('action', 'deactivate_domain');
          FD.append('domain', e.target.dataset.domain);
          FD.append('key', e.target.dataset.key);

          if (confirm(`Are you sure you want to deactivate '${e.target.dataset.domain}'?`)) {
            const response = await fetch('/wp-admin/admin-ajax.php', {
              method: 'POST',
              body:   FD,
            });

            const json = await response.json();

            if (json.success) {
              location.reload();
              return;
            }

            alert(json.data.message);
          }
        });
      });
});

